<script lang="ts">
    import Column from "../../materialize/grid/Column.svelte";
    import Row from "../../materialize/grid/Row.svelte";
    import AudioButton from "../../utils/AudioButton.svelte";
    import type { Word } from "../../dictionary/Word";
    import ShareButton from "../../utils/ShareButton.svelte";
    import {genders, scopes, lexical_categories} from "../../stores/stores";
    import {get_host} from "../../settings";
    import WordAudioButton from "./WordAudioButton.svelte";
    export let word: Word;
</script>

<Row>
    <Column small={12}>
        <h4>{word.word}
            <WordAudioButton {word}></WordAudioButton>
            
        </h4>
    </Column>
    {#if word.definition}
    <Column small={6}> <p style="word-wrap: break-word;"></p>{word.definition ? word.definition : ""}</Column>
    {/if}
    {#if word.lexical_category}
        {$lexical_categories.find( (el) => {return el.id == word.lexical_category} ).name }
        {$lexical_categories.find( (el) => {return el.id == word.lexical_category} ).subtype }
    {/if}
    {#if word.gender}
    	{$genders.find((el)=>{return el.id == word.gender}).gender}
    {/if}
    {#if word.scope}
        ambito {$scopes.find((el)=>{return el.id == word.scope}).scope}
    {/if}
    
    <!-- <ShareButton></ShareButton> -->
    
</Row>
